import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String }

  async load(event) {
    event.preventDefault()
    const response = await fetch(this.urlValue, {
      headers: { Accept: "text/vnd.turbo-stream.html" }
    })
    if (response.ok) {
      Turbo.renderStreamMessage(await response.text())
    }
  }
}
